module.exports = "<app-main></app-main>\n"